module.exports = __webpack_public_path__ + "static/media/hope.a4beb252.png";